<template>
  <div>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Filtros
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row no-gutters>
            <v-col cols="12" md="4">
              <date-input
                v-model="fechaFrom"
                label="Fecha desde"
                @enter="onKeyboardEnter"
                clearable
              ></date-input>
            </v-col>
            <v-col cols="12" md="4">
              <date-input
                v-model="fechaTo"
                label="Fecha hasta"
                @enter="onKeyboardEnter"
                clearable
              ></date-input>
            </v-col>
            <v-col cols="12" md="6">
              <v-checkbox
                :value="borradas"
                label="Mostrar transacciones borradas"
                @change="onChangeCheckboxBorradas"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="6">
              <v-checkbox
                :value="pendientes"
                label="Mostrar transacciones con saldo pendiente"
                @change="onChangeCheckboxPendientes"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DateInput from '@/components/DateInput'
export default {
  name: 'TransaccionesFiltersComponent',
  components: {
    'date-input': DateInput
  },
  data () {
    return {
      //
    }
  },
  beforeMount () {
    // Agrega el event listener en el gancho beforeMount
    window.addEventListener('keydown', this.handleKeyboard);
  },
  beforeDestroy () {
    // Remueve el event listener en el gancho beforeDestroy
    window.removeEventListener('keydown', this.handleKeyboard);
    this.onClearFilters();
  },
  created () {
    //
  },
  computed: {
    ...mapGetters('Transacciones', ['loading', 'itemsLength', 'filters', 'options', 'sort']),
    sortBy: {
      get () {
        return this.sort.by
      },
      set (value) {
        this.setSortBy(value)
      }
    },
    sortDesc: {
      get () {
        return this.sort.desc
      },
      set (value) {
        this.setSortDesc(value)
      }
    },
    fechaFrom: {
      get () {
        return this.filters.fecha_from
      },
      set (value) {
        this.setFilters({
          ...this.filters,
          fecha_from: value
        })
      }
    },
    fechaTo: {
      get () {
        return this.filters.fecha_to
      },
      set (value) {
        this.setFilters({
          ...this.filters,
          fecha_to: value
        })
      }
    },
    borradas: {
      get () {
        return this.filters.borradas
      },
      set (value) {
        this.setFilters({
          ...this.filters,
          borradas: value
        })
      }
    },
    pendientes: {
      get () {
        return this.filters.pendientes
      },
      set (value) {
        this.setFilters({
          ...this.filters,
          pendientes: value
        })
      }
    },
    cantidad: {
      get () {
        return this.filters.cantidad
      },
      set (value) {
        this.setFilters({
          ...this.filters,
          cantidad: value
        })
      }
    },
    productos: {
      get () {
        return this.filters.productos
      },
      set (value) {
        this.setFilters({
          ...this.filters,
          productos: value
        })
      }
    },
    formasPagos: {
      get () {
        return this.filters.formas_pagos
      },
      set (value) {
        this.setFilters({
          ...this.filters,
          formas_pagos: value
        })
      }
    },
  },
  methods: {
    ...mapActions('Transacciones', ['onClearFilters', 'onFetch']),
    ...mapMutations('Transacciones', ['setFilters', 'setOptions', 'setSortBy', 'setSortDesc']),
    handleKeyboard(event) {
      // if(event.key === "F1" && !event.ctrlKey) {
      //   event.preventDefault()
      // }
    },
    onChangeCheckboxBorradas (value) {
      this.borradas = value ? 1:0;
      this.onFetch()
    },
    onChangeCheckboxPendientes (value) {
      this.pendientes = value ? 1:0;
      this.onFetch()
    },
    onKeyboardEnter (event) {
      event.preventDefault();
      this.onFetch()
      //
    }
  }
}
</script>
